module.exports = __webpack_public_path__ + "img/addresses.5a0ecc6c.svg";